module.exports = __webpack_public_path__ + "img/00banner yellow.e38b5bad.webp";